import { menuState } from 'js/main';

export default function (menuState, restoreTabIndexToToggleButton, setTabIndexToFirstTappableElement) {
	const toggleButton = document.getElementById('js-mobile-menu-toggle');
	const navigation = document.querySelector('.header__navigation');
	const header = document.getElementById('header');
	const breakpoint = 900; // matches $width--nav-mobile

	// Debugging
	if (menuState.debug) console.log(menuState);

	if (!toggleButton || !navigation || !header) return;

	const closeMenu = () => {
		if (navigation.classList.contains('--is-opened')) {
			if (menuState.debug) console.log('Closing mobile header menu');
			toggleButton.classList.remove('--is-active');
			navigation.classList.remove('--is-opened');
			header.classList.remove('--is-opened');
			restoreTabIndexToToggleButton();
		}
	};

	const toggleClasses = () => {
		if (menuState.debug) console.log('Toggling header menu visibility');
		if (menuState.openMenu && menuState.openMenu !== 'mobile') {
			menuState.closeCurrentMenu();
		}

		menuState.openMenu = navigation.classList.contains('--is-opened') ? null : 'mobile';
		menuState.closeCurrentMenu = closeMenu;

		toggleButton.classList.toggle('--is-active');
		navigation.classList.toggle('--is-opened');
		header.classList.toggle('--is-opened');
		if (document.querySelector('body')?.classList.contains('--search-is-open')) {
			const searchToggle = document.getElementById('js-header-search-toggle');
			if (searchToggle) searchToggle.click();
		}

		if (navigation.classList.contains('--is-opened')) {
			setTabIndexToFirstTappableElement();
		} else {
			restoreTabIndexToToggleButton();
		}
	};

	const handleClick = () => {
		if (window.innerWidth < breakpoint) {
			toggleClasses();
		}
	};

	toggleButton.addEventListener('click', handleClick);
}
